<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zAodik/cover.jpeg?1684245185981" alt="This image is the cover for the book Master of the Sky, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Master of the Sky, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Lin Yi accidentally crossed over to a foreign world and became a good-for-nothing youth.</strong> </p><p>He relied on the benefits of being a Transcender of Light to rise to prominence. He slaughtered gods and buddhas along the way, and even shook the nine heavens …</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        You Wo, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?caaab99c